import { z } from "zod";
import { GLASS_POSITIONS, JOB_TYPES } from "./enums.js";

/**
 * Per dealer group or store. Lets AGW turn job types and glass options on or off
 * and require extra fields without a code change (the Bifrost leadFormConfig pattern).
 */
export const formConfigSchema = z.object({
  enabledJobTypes: z.array(z.enum(JOB_TYPES)).min(1),
  enabledGlassPositions: z.array(z.enum(GLASS_POSITIONS)).min(1),
  requireRoNumber: z.boolean().default(false),
  requireStockNumber: z.boolean().default(false),
  requiredPhotoKinds: z.array(z.string()).default(["damage", "insurance_card", "vin_plate"]),
});
export type FormConfig = z.infer<typeof formConfigSchema>;

export const DEFAULT_FORM_CONFIG: FormConfig = {
  enabledJobTypes: [...JOB_TYPES],
  enabledGlassPositions: [...GLASS_POSITIONS],
  requireRoNumber: false,
  requireStockNumber: false,
  requiredPhotoKinds: ["damage", "insurance_card", "vin_plate"],
};
